import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { getMapExtent, getCurrentBasemap} from '../esri/mapHub';
import symbols from '../../defaults/Symbols.json'

export class NewIncidentMap extends Component
{
  constructor(props)
  {
     super(props);
     this.state =
     {
       mapIsLoaded: false,
       userLatitude: null,
       userLongitude: null,
       manualLat: props.manualLat,
       manualLong: props.manualLong
     };

      this.mapRef = React.createRef();
      this.startup();
   }

   componentWillReceiveProps(nextProps)
   {
     if(!this.state.mapIsLoaded && nextProps.open && !this.props.open)
     {
       this.startup();
     }

     if(nextProps.manualLat !== this.state.manualLat || nextProps.manualLong !== this.state.manualLong)
     {
       this.updatePoint(nextProps.manualLat, nextProps.manualLong);
     }
   }

   shouldComponentUpdate(nextProps, nextState)
   {
     return false;
   }

   componentWillUnmount()
   {
     // Clean up jsapi's dirty little mess
   }

   render()
   {
     return (
       <div className="webmap" ref={this.mapRef}></div>
     );
   }

   updatePoint = (manualLat, manualLong) =>
   {
     if (manualLat === this.state.userLatitude && manualLong === this.state.userLongitude)
     {
       return;
     }

     loadModules(['esri/geometry/coordinateFormatter', 'esri/Graphic', 'esri/symbols/SimpleMarkerSymbol'])
     .then( ([coordinateFormatter, Graphic, SimpleMarkerSymbol]) =>
     {
       // Load dependencies of "coordinateFormatter" module
       coordinateFormatter.load().then(() =>
       {
         var newPoint = coordinateFormatter.fromLatitudeLongitude(manualLat + " " + manualLong);

         this.setState({
           userLatitude: manualLat,
           userLongitude: manualLong
         });

         this.props.onCoordinateUpdate(manualLat, manualLong);

         this.originGraphicsLayer.removeAll();

         this.originGraphicsLayer.graphics.add(
           new Graphic(
             {
               geometry: newPoint,
               symbol:  new SimpleMarkerSymbol(symbols.newIncidentSymbol)
             })
         );

         this.view.center = newPoint;
         console.log(newPoint);

      });
     });
   }

  startup = () =>
  {
    loadModules([
      'esri/Map',
      'esri/views/MapView',
      'esri/widgets/BasemapToggle',
      'esri/layers/GraphicsLayer',
      'esri/Graphic',
      'esri/symbols/SimpleMarkerSymbol',
      'esri/widgets/Search'], { css: true })
   .then(([
     ArcGISMap,
     MapView,
     BasemapToggle,
     GraphicsLayer,
     Graphic,
     SimpleMarkerSymbol,
     Search]) =>
   {
     const map = new ArcGISMap({
       basemap: 'topo-vector'
     });

     this.view = new MapView({
       container: this.mapRef.current,
       map: map,
       center: [-118, 34],
       zoom: 8
     });

     this.basemapToggle = new BasemapToggle({
        view: this.view
      });

     this.map = this.view.map;
     this.view.ui.add(this.basemapToggle, 'bottom-right');

     let originGraphicsLayer = new GraphicsLayer();
     map.add(originGraphicsLayer);
     this.originGraphicsLayer = originGraphicsLayer;

     //Set map extent to main map extent
     getMapExtent().then(
      result =>
        {
          this.view.extent = result;
        }
      );

      //Set map extent to main map extent
      /*getCurrentBasemap().then(
       result =>
         {
          if (result.id !== this.view.map.basemap.id)
          {
            this.view.map.basemap = result.id;
            this.basemapToggle.nextBasemap = (result.id === "satellite") ? 'topo-vector' : 'satellite';
            //this.basemapToggle.activeBasemap = (result.id === "satellite") ? 'satellite' : 'topo-vector';
          }
         }
       ); */

    //handler to move new incident graphic to user click point
    this.view.on("click", (event) =>
    {
      this.setState({
        userLatitude: event.mapPoint.latitude,
        userLongitude: event.mapPoint.longitude
      });

      this.props.onCoordinateUpdate(event.mapPoint.latitude, event.mapPoint.longitude);

      this.originGraphicsLayer.removeAll();

      this.originGraphicsLayer.graphics.add(
        new Graphic(
          {
            geometry: event.mapPoint,
            symbol:  new SimpleMarkerSymbol(symbols.newIncidentSymbol)
          })
        );
      });

        let search = new Search();
        this.view.ui.add(search, {
          position: "top-right"
        });

        this.search = search;

        this.search.on('select-result', (event) => {
          this.view.extent = event.result.extent.extent;
        });

     this.setState({
       mapIsLoaded: true
     });
   }

   );
 }
}

export default NewIncidentMap;
